import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { ArrowLeft, Package, ChevronRight } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL || ''}/api`;

export default function MobileRDPendingItemsPage() {
  const navigate = useNavigate();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API}/rd/pending-items`).then(r => setItems(r.data || [])).catch(() => {}).finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="mobile-page"><div className="mobile-loading"><div className="mobile-spinner" /></div></div>;

  return (
    <div className="mobile-page">
      <button className="mobile-back-btn" onClick={() => navigate('/mobile/more')}><ArrowLeft size={18} /> More</button>
      <div className="mobile-page-title" style={{ marginBottom: 12 }}>Pending Items</div>
      <div className="mobile-kpi-row" style={{ marginBottom: 14 }}>
        <div className="mobile-kpi-card orange"><div className="mobile-kpi-label">Pending</div><div className="mobile-kpi-value">{items.length}</div></div>
      </div>
      {items.length === 0 ? <div className="mobile-empty-state"><Package /><p>No pending items</p></div> : (
        <div className="mobile-menu-list">
          {items.map(item => (
            <button key={item.item_id || item.id} className="mobile-menu-item" onClick={() => navigate('/mobile/rd/pending-items')}>
              <div className="mobile-menu-item-icon" style={{ background: '#ff9500' }}><Package size={16} /></div>
              <div className="mobile-menu-item-content">
                <div className="mobile-menu-item-title">{item.name || item.item_name}</div>
                <div className="mobile-menu-item-subtitle">{item.status || 'pending'} · {item.project_name || ''}</div>
              </div>
              <ChevronRight size={16} className="mobile-menu-item-chevron" />
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
